import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { TableReservation, TableReservationCreate, TableReservationFilter } from '../data/tableReservation';

export function createTableReservationService(client: AxiosInstance) {
  return createCrudService<TableReservation, TableReservationCreate, TableReservationFilter>(
    client,
    '/restaurant/TableReservation',
    'id',
  );
}

export type TableReservationService = CrudService<TableReservation, TableReservationCreate, TableReservationFilter>;
